<div mat-dialog-title>{{ translations?.RESULTS_SETTINGS_DIALOG?.TITLE || 'Results Settings' }}</div>
<mat-dialog-content>
	<div>
		<mat-slide-toggle
			[(ngModel)]="options.showOnlyTopResults"
			[aria-label]="
				!options.showOnlyTopResults ? 'Check to show only top 100 results' : 'Un-checked to show all the results'
			">
			{{ translations?.RESULTS_SETTINGS_DIALOG?.SHOW_TOP_100_RESULT || 'Show only top 100 relevant results' }}
		</mat-slide-toggle>
	</div>
	<div>
		<mat-divider></mat-divider>
	</div>
	<div>
		<mat-checkbox
			ariachec
			[(ngModel)]="options.showIdentical"
			[aria-label]="
				!options.showIdentical ? 'Check to include identical results' : 'Un-Check to exclude identical results'
			">
			{{ translations?.SHARED?.MATCH_TYPES?.IDENTICAL || 'Identical' }}
		</mat-checkbox>
	</div>
	<div>
		<mat-checkbox
			[(ngModel)]="options.showMinorChanges"
			[aria-label]="
				options.showMinorChanges
					? 'Un-check to exclude minor changes results'
					: 'Check to include minor changes results'
			">
			{{ translations?.SHARED?.MATCH_TYPES?.MINOR_CHANGES || 'Minor Changes' }}
		</mat-checkbox>
	</div>
	<div>
		<mat-checkbox
			[(ngModel)]="options.showRelated"
			[aria-label]="
				!options.showRelated ? 'Check to include paraphrased results' : 'Un-check to exclude paraphrased results '
			">
			{{ translations?.SHARED?.MATCH_TYPES?.RELATED_MEANING || 'Paraphrased' }}
		</mat-checkbox>
	</div>
</mat-dialog-content>

<div fxLayout.lt-md="column nowrap" fxLayout="row nowrap" fxLayoutGap="1em" fxLayoutAlign="end center">
	<!-- <mat-checkbox fxFlexAlign.lt-md="start" [(ngModel)]="options.setAsDefault">
		{{ translations?.RESULTS_SETTINGS_DIALOG?.SET_DEFAULT || 'Set as default for all scans' }}
	</mat-checkbox> -->
	<button mat-raised-button (click)="close(true)" color="primary" aria-label="Saves the desired results settings.'">
		{{ translations?.SHARED?.SAVE || 'SAVE' }}
	</button>
</div>
<button
	close
	mat-icon-button
	(click)="close()"
	[class]="'close-' + directionService.dir"
	aria-label="Closes results settings.">
	<mat-icon svgIcon="close_black_color"></mat-icon>
</button>
